import React from 'react';
import PropTypes from 'prop-types';
import { useGetProductCategoriesQuery } from '../../../redux-modules/service';
import { Close } from '../../ui/icon/Close';
import { Filter } from '../../ui/icon/Filter';

export default function CategoryFilter({
  currentCategory,
  onCategoryChanged,
  additionalData,
}) {
  const { data: categoryData, isFetching: isCategoryDataFetching } = useGetProductCategoriesQuery();

  const { translates } = additionalData;
  const { catalog } = translates;

  if (isCategoryDataFetching || categoryData.categories.length === 0) {
    return Craft.t(catalog, 'Loading...');
  }

  const root = categoryData.categories[0];

  return (
    <>
      <button
        className="category-main-opener d-lg-none"
        type="button"
        onClick={() => { document.getElementById('category-bar').classList.add('category-active'); }}
      >
        <Filter width="14" height="13" />
        {Craft.t(catalog, 'Browse categories')}
      </button>
      <div className="category-bar" id="category-bar">
        <div className="category-content-drop">
          <button
            className="category-close"
            type="button"
            onClick={() => { document.getElementById('category-bar').classList.remove('category-active'); }}
          >
            {Craft.t(catalog, 'Browse categories')}
            <Close />
          </button>
          <div className="category-drop-inner">
            <ul className="category-list accordion" id="accordion-filter">
              <li className={currentCategory === root.id ? 'active' : ''}>
                <a
                  href={root.url}
                  onClick={(e) => {
                    onCategoryChanged(root.uri);
                    window.history.pushState(null, '', root.url);
                    document.getElementById('category-bar').classList.remove('category-active');
                    e.preventDefault();
                  }}
                >
                  {Craft.t(catalog, 'All categories')}
                </a>
              </li>
              {root.children.map((category, index) => {
                const hasActiveCategory = Boolean(currentCategory && currentCategory !== 'all-categories');

                const isDefaultOpen = !hasActiveCategory && index === 0;

                const active = (currentCategory && currentCategory.includes(category.uri))
                  || isDefaultOpen;

                return (category.productCount.length && (
                  <li key={category.id}>
                    <a
                      className={`category-opener ${active ? 'collapsed' : ''}`}
                      href={category.url}
                      data-bs-toggle="collapse"
                      data-bs-target={`#category-item-${category.id}`}
                      aria-expanded={active ? 'true' : 'false'}
                      aria-controls={`category-item-${category.id}`}
                    >
                      {category.title}
                    </a>
                    <div
                      className={`collapse ${active ? 'show' : ''}`}
                      id={`category-item-${category.id}`}
                      data-bs-parent="#accordion-filter"
                    >
                      <ul id="accordion-filter-sub">
                        <li className={currentCategory === category.id ? 'active' : ''}>
                          <a
                            href={category.url}
                            onClick={(e) => {
                              onCategoryChanged(category.uri);
                              window.history.pushState(null, '', category.url);
                              e.preventDefault();
                            }}
                          >
                            {Craft.t(catalog, 'All {category}', { category: category.title })}
                          </a>
                        </li>
                        {category.children.map((subcategory) => {
                          const subActive = currentCategory.includes(subcategory.uri);
                          return subcategory.productCount.length && (
                            subcategory.children.length > 0 ? (
                              <li key={subcategory.id}>
                                <a
                                  className={`category-opener ${subActive ? 'collapsed' : ''}`}
                                  href={subcategory.url}
                                  data-bs-toggle="collapse"
                                  data-bs-target={`#category-item-${subcategory.id}`}
                                  aria-expanded={subActive ? 'true' : 'false'}
                                  aria-controls={`category-item-${subcategory.id}`}
                                >
                                  {subcategory.title}
                                </a>
                                <div
                                  className={`collapse ${subActive ? 'show' : ''}`}
                                  id={`category-item-${subcategory.id}`}
                                  data-bs-parent="#accordion-filter-sub"
                                >
                                  <ul>
                                    <li className={currentCategory === subcategory.uri ? 'active' : null}>
                                      <a
                                        href={subcategory.url}
                                        onClick={(e) => {
                                          onCategoryChanged(subcategory.uri);
                                          window.history.pushState(null, '', subcategory.url);
                                          e.preventDefault();
                                        }}
                                      >
                                        {Craft.t(catalog, 'All {category}', { category: subcategory.title })}
                                      </a>
                                    </li>
                                    {subcategory.children.map((subSubCategory) => (
                                      <li
                                        key={subSubCategory.id}
                                        className={currentCategory === subSubCategory.uri ? 'active' : null}
                                      >
                                        <a
                                          href={subSubCategory.url}
                                          onClick={(e) => {
                                            onCategoryChanged(subSubCategory.uri);
                                            window.history.pushState(null, '', subSubCategory.url);
                                            e.preventDefault();
                                          }}
                                        >
                                          {subSubCategory.title}
                                        </a>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </li>
                            ) : (
                              <li key={subcategory.id} className={subActive ? 'active' : null}>
                                <a
                                  href={subcategory.url}
                                  onClick={(e) => {
                                    onCategoryChanged(subcategory.uri);
                                    window.history.pushState(null, '', subcategory.url);
                                    e.preventDefault();
                                  }}
                                >
                                  {subcategory.title}
                                </a>
                              </li>
                            )
                          );
                        })}
                      </ul>
                    </div>
                  </li>
                ));
              })}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

CategoryFilter.propTypes = {
  currentCategory: PropTypes.string,
  onCategoryChanged: PropTypes.func,
  additionalData: PropTypes.objectOf(PropTypes.any),
};
